import "./styles.scss";

import { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { getCompletedQuestionnaires } from "../../store/middleware";

function ModalQuestionnairesView({ userId, showModal, setShowModal }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const { completedQuestionnaires } = useSelector((state) => state.questionnairesReducer);

  const closeModal = () => setShowModal(false);

  const getData = async (id) => await dispatch(getCompletedQuestionnaires(id));

  useEffect(() => {
    getData(userId);
    // eslint-disable-next-line
  }, [userId]);

  return (
    <Dialog open={showModal} onClose={closeModal} classes="modalQuestionnaires" className="modalQuestionnaires">
      <div className="containerQuestionnaires">
        <h3 className="title">{t("Questionnaires")}</h3>

        <form className="contentQuestionnaires">
          {completedQuestionnaires?.map((item) => (
            <div key={item.answerId}>
              <ul>
                <li>
                  <h4 className="subTitle">{item?.titleTranslations[language]}</h4>
                </li>
              </ul>

              {item?.translatedAnswersEnriched[language]?.map((answerItem) => (
                <div key={answerItem.id} className="contentAnswers">
                  <h5 className="questionTitle">{answerItem.question}</h5>
                  <p className="questionAnswer">{answerItem.answer || ""}</p>
                </div>
              ))}

              <div className="separator" />
            </div>
          ))}
          {completedQuestionnaires?.length === 0 && <p className="noResults">{t("NO_RESULTS")}</p>}
        </form>

        <div className="footer">
          <button className="buttonModalSave" onClick={closeModal}>
            {t("BTN_CLOSE")}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalQuestionnairesView;
